import React from 'react';
import { Icon } from './Icon.js';
export const IconLayoutSidebarFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M14.25,16H4v-1.5H14.25c.689,0,1.25-.561,1.25-1.25V4.75c0-.689-.561-1.25-1.25-1.25H4v-1.5H14.25c1.517,0,2.75,1.233,2.75,2.75V13.25c0,1.517-1.233,2.75-2.75,2.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "1", y: "2", width: "6", height: "14", rx: "2.75", ry: "2.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconLayoutSidebarFill18.js.map